import { translateApiErrorKey } from '@/lib/api-error'

/**
 * **Der Fehler eines Hintergrundlaufs als Satz** (10.10.2026, Befund R-25).
 *
 * Ein KI-Lauf im Hintergrund (Lesung, Posteingang, Kalkulation) hat keine Antwort, an der die Oberfläche einen
 * Fehler übersetzen könnte: Der Server legt ab, was er hat — den i18n-Schlüssel (`contracts.aiContractRequired`)
 * oder den Code (`AI_CONTRACT_REQUIRED`) —, und die Maske zeigte genau das. Aufgefallen am fehlenden KI-Zusatz:
 * Statt „Für die KI über Symphenia muss dein Betrieb zuerst den KI-Zusatz … annehmen" stand der rohe Schlüssel da.
 *
 * Jede Stelle, die den gespeicherten Fehler eines Laufs zeigt, führt ihn hier durch: Ein bekannter Code wird sein
 * Schlüssel, ein Schlüssel sein Satz aus den Sprachdateien; alles andere (ein Satz des Servers) bleibt, wie es ist.
 */
const SCHLUESSEL_ZUM_CODE: Record<string, string> = {
  AI_CONTRACT_REQUIRED: 'contracts.aiContractRequired',
}

export function laufFehlerText(fehler: string | null | undefined, uebersetze: (text: string, sonst: string) => string = translateApiErrorKey): string {
  const roh = (fehler ?? '').trim()
  if (!roh) return ''
  // Ohne Übersetzung bleibt stehen, was der Server abgelegt hat — besser der Schlüssel als gar nichts.
  return uebersetze(SCHLUESSEL_ZUM_CODE[roh] ?? roh, roh)
}
